<template>
  <div>
    <p class="cp-help-text">
      Your order file/files are needed now. You can provide it/them as a link to a publicly available download or upload
      the file/files directly. The type of file/files needed is indicated below.
    </p>

    <br>
    <div class="columns">
      <div class="column is-12-mobile is-7 is-7-desktop cp-left-column">
        <div v-for="(product, key) of cartProducts" v-bind:key="key">
          <div class="card events-card">
            <header class="card-header" style="display: block; padding: 6px 7px 15px;">
              <div class="card-header-title" style="padding-bottom: 0;">
                {{ product.cpProductInfo.name }}
              </div>
              <small style="padding-left: 0.75rem;" v-for="option in getProductOptions(key)" v-bind:key="option"> –
                {{ option }}<br>
              </small>
            </header>
            <div class="card-table">
              <div class="content" style="padding: 7px 20px 3px;">
                <template v-if="product.type === 'stock'">
                  <br>
                  <p>It is the stock product. The files is not needed.</p>
                </template>
                <template v-else>
                  <div v-for="file in getFileTypesForCartItem(product)" v-bind:key="file.type">
                    <br>
                    <p style="border-bottom: 1px solid #dbdbdb">
                      {{ file.type.charAt(0).toUpperCase() + file.type.slice(1) + ' file' }}
                    </p>
                    <div class="full-width">
                      <b-field
                        label="How will you provide the files"
                        class="has-text-left product-file-field"
                        :addons="false"
                        :type="{'is-danger': errors.has('file_form.file storage ' + key)}"
                        :message="errors.first('file_form.file storage ' + key)">
                        <div>
                          <b-radio v-if="product.cp_files.original"
                                   v-model="product.file_storage[file.type]"
                                   v-validate="'required'"
                                   data-vv-scope="file_form"
                                   :name="'file storage ' + key + ' ' + file.type"
                                   :data-vv-as="file.type + 'file storage'"
                                   native-value="original_file">
                            Use the file links from the original order
                          </b-radio>
                        </div>

                        <div>
                          <b-radio v-model="product.file_storage[file.type]"
                                   v-validate="'required'"
                                   data-vv-scope="file_form"
                                   :name="'file storage ' + key + ' ' + file.type"
                                   :data-vv-as="file.type + 'file storage'"
                                   native-value="link">
                            Set a public link to the files
                          </b-radio>
                        </div>

                        <div>
                          <b-radio v-model="product.file_storage[file.type]"
                                   v-validate="'required'"
                                   data-vv-scope="file_form"
                                   :name="'file storage ' + key + ' ' + file.type"
                                   :data-vv-as="file.type + 'file storage'"
                                   native-value="upload">
                            Upload the files from your local computer
                          </b-radio>
                        </div>

                        <div v-if="product.cp_files.dropbox">
                          <b-radio v-model="product.file_storage[file.type]"
                                   v-validate="'required'"
                                   data-vv-scope="file_form"
                                   :name="'file storage ' + key + ' ' + file.type"
                                   :data-vv-as="file.type + 'file storage'"
                                   @input="initDropbox(key, file.type, file.format)"
                                   native-value="dropbox">
                            Select the file from Dropbox
                          </b-radio>
                        </div>
                      </b-field>

                      <b-field
                        v-if="product.file_storage[file.type] == 'original_file'"
                        :label="file.type.charAt(0).toUpperCase() + file.type.slice(1) + ' ' + file.format +  ' file url'"
                        custom-class="required-field"
                        :type="{'is-danger': errors.has('file_form.' + file.type + ' ' + file.format.toUpperCase() + ' file url ' + key)}"
                        :message="errors.first('file_form.' + file.type + ' ' + file.format.toUpperCase() + ' file url ' + key)">
                        <b-input v-model="product.cp_files.original[file.type]"
                                 v-validate="{ required: true, url: { require_protocol: true }, file_exists: true }"
                                 disabled
                                 data-vv-scope="file_form"
                                 :data-vv-as="file.format + ' file url'"
                                 :name="file.type + ' ' + file.format.toUpperCase() + ' file url ' + key"></b-input>
                      </b-field>

                      <b-field
                        v-if="product.file_storage[file.type] == 'link'"
                        :label="file.type.charAt(0).toUpperCase() + file.type.slice(1) + ' ' + file.format +  ' file url'"
                        custom-class="required-field"
                        :type="{'is-danger': errors.has('file_form.' + file.type + ' ' + file.format.toUpperCase() + ' file url ' + key)}"
                        :message="errors.first('file_form.' + file.type + ' ' + file.format.toUpperCase() + ' file url ' + key)">
                        <b-input v-model="product.cp_files.link[file.type]"
                                 v-validate="{url: {require_protocol: true }, required:true}"
                                 data-vv-scope="file_form"
                                 :data-vv-as="file.type + ' file url'"
                                 :name="file.type + ' ' + file.format.toUpperCase() + ' file url ' + key"></b-input>
                      </b-field>

                      <b-field class="file"
                               v-if="product.file_storage[file.type] == 'upload'"
                               :type="{'is-danger': errors.has('file_form.' + file.type + ' ' + file.format + key)}"
                               :message="errors.first('file_form.' + file.type + ' ' + file.format + key)">
                        <b-upload :id="'file-' + file.type + '-' + key"
                                  v-model="product.cp_files.upload[file.type]"
                                  :accept="'.' + file.format"
                                  v-validate="{'required':true, 'ext':file.format}"
                                  data-vv-scope="file_form"
                                  :data-vv-as="file.type + ' file'"
                                  :name="file.type + ' ' + file.format + key">
                          <a class="button is-primary">
                            <b-icon icon="upload"></b-icon>
                            <span>{{
                                file.type.charAt(0).toUpperCase() + file.type.slice(1)
                              }} {{ file.format.toUpperCase() }}</span>
                          </a>
                        </b-upload>
                        <span class="file-name">
                              <span
                                v-if="product.cp_files.upload[file.type] && product.cp_files.upload[file.type].name">
                                {{ product.cp_files.upload[file.type].name }}
                              </span>
                              <span v-else>Not selected</span>
                          </span>
                      </b-field>

                      <div :id="`dropbox_product_${key}_${file.type}`"
                           v-if="product.cp_files.dropbox"
                           v-show="product.file_storage[file.type] == 'dropbox'">
                        <span class="dropbox_btn_container"></span>
                        <span v-if="product.cp_files.dropbox && product.cp_files.dropbox[file.type] && product.cp_files.dropbox[file.type].name">
                           {{product.cp_files.dropbox[file.type].name}}
                        </span>
                        <span class="dropbox_input">
                           <b-field class="file"
                                    :type="{'is-danger': errors.has('file_form.' + file.type + ' ' + file.format + key)}"
                                    :message="errors.first('file_form.' + file.type + ' ' + file.format + key)">
                              <b-input :name="file.type + ' ' + file.format + key"
                                       v-model="product.cp_files.dropbox[file.type].name"
                                       type="hidden"
                                       v-validate="{'required': product.file_storage[file.type] == 'dropbox'}"
                                       data-vv-scope="file_form"
                                       :data-vv-as="file.type + ' file'"
                              ></b-input>
                           </b-field>
                        </span>

                      </div>
                    </div>

                    <br>
                  </div>
                </template>
                <br>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="column is-12-mobile is-5 is-5-desktop cp-right-column-file">
        <OrderOverview :priceCheck="orderData.priceCheckResponse"/>
      </div>
    </div>
  </div>
</template>

<script>
import OrderOverview from '@/components/order-create/OrderOverview'
import ProductMixin from '@/mixins/ProductMixin'
import { getFileTypesForCartItem } from '../../utils/file-types';

export default {
  name: 'FileSetup',
  mixins: [ProductMixin],
  components: {OrderOverview},

  data() {
    return {
      orderData: {},
      cartProducts: []
    }
  },

  mounted() {
    let dropBox = document.createElement("script");
    dropBox.setAttribute(
      "src",
      "https://www.dropbox.com/static/api/2/dropins.js"
    );
    dropBox.setAttribute("id", "dropboxjs");
    dropBox.setAttribute("data-app-key", "pk0n92jdis688bc");
    document.head.appendChild(dropBox);
  },

  created() {
    this.orderData = this.$store.getters['cpOrder/allData']
    this.cartProducts = this.$store.getters['cart/products']
  },

  methods: {
    getFileTypesForCartItem,
    initDropbox: function (productKey, fileType, fileFormat) {
      let options = {
        success: async files => {
          this.cartProducts[productKey].cp_files.dropbox[fileType] = {
            name: files[0].name,
            link: files[0].link.slice(0, -1) + '1'
          }
        },
        extensions: [
          "." + fileFormat,
        ],
      };
      const button = Dropbox.createChooseButton(options);
      const dropboxBtnElement = document.getElementById(`dropbox_product_${productKey}_${fileType}`)
        .getElementsByClassName('dropbox_btn_container')[0];

      if (!dropboxBtnElement.innerHTML) {
        dropboxBtnElement.appendChild(button)
      };
    }
  }
}
</script>
